import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import {
  getTasksForTransaction,
  sendTransactionStatusChangedNotificationEmails,
  updateTaskInDb,
  updateTransStatusInDb,
} from "../../../app/firestore/firestoreService";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { updateTransactionTransAll } from "../transactionSlice";
import { openModal } from "../../../app/common/modals/modalSlice";

export default function TransactionActionButtons({ transaction }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentUserProfile } = useSelector((state) => state.profile);
  const isMobile = useMediaQuery({ query: "(max-width:768px)" });
  const location = useLocation();
  const lastPath = location.pathname.substring(
    location.pathname.lastIndexOf("/") + 1
  );

  function handleView() {
    navigate(`/transactions/${transaction.id}/overview`);
  }

  async function handleSetUnderContract() {
    const oldStatus = transaction.status;
    try {
      await updateTransStatusInDb(transaction.id, {
        status: "Under Contract",
        statusPrevious: transaction.status,
        active: true,
      });
      if (lastPath === "transactionsAll") {
        dispatch(
          updateTransactionTransAll({
            id: transaction.id,
            fields: {
              status: "Under Contract",
              statusPrevious: transaction.status,
            },
          })
        );
      }
      // Send status change notification
      sendTransactionStatusChangedNotificationEmails(
        transaction,
        oldStatus,
        "Under Contract",
        currentUserProfile
      );
      toast.success("Transaction status set to Under Contract");
    } catch (error) {
      toast.error(error.message);
    }
  }

  async function handleSetComplete() {
    const oldStatus = transaction.status;
    try {
      await updateTransStatusInDb(transaction.id, {
        status: "Complete",
        statusPrevious: transaction.status,
        active: false,
      });
      if (lastPath === "transactionsAll") {
        dispatch(
          updateTransactionTransAll({
            id: transaction.id,
            fields: {
              status: "Complete",
              statusPrevious: transaction.status,
            },
          })
        );
      }
      // Send status change notification
      sendTransactionStatusChangedNotificationEmails(
        transaction,
        oldStatus,
        "Complete",
        currentUserProfile
      );
      toast.success("Transaction status set to Complete");
    } catch (error) {
      toast.error(error.message);
    }
  }

  async function handleArchive() {
    const oldStatus = transaction.status;
    try {
      await updateTransStatusInDb(transaction.id, {
        status: "Archived",
        statusPrevious: transaction.status,
        active: false,
      });
      let tasks = await getTasksForTransaction(transaction.id);
      if (tasks) {
        tasks.forEach((task) => {
          updateTaskInDb(task.id, { archived: true });
        });
      }
      if (lastPath === "transactionsAll") {
        dispatch(
          updateTransactionTransAll({
            id: transaction.id,
            fields: {
              status: "Archived",
              statusPrevious: transaction.status,
            },
          })
        );
      }
      // Send status change notification
      sendTransactionStatusChangedNotificationEmails(
        transaction,
        oldStatus,
        "Archived",
        currentUserProfile
      );
      toast.success("Transaction successfully archived");
    } catch (error) {
      toast.error(error.message);
    } finally {
    }
  }

  async function handleMakeActive() {
    const oldStatus = transaction.status;
    const newStatus =
      transaction.statusPrevious ||
      (transaction.agentRepresents === "Buyer" && "Active Buyer") ||
      (transaction.agentRepresents === "Seller" && "Active Listing");
    try {
      await updateTransStatusInDb(transaction.id, {
        active: true,
        status: newStatus,
      });
      let tasks = await getTasksForTransaction(transaction.id);
      if (tasks) {
        tasks.forEach((task) => {
          updateTaskInDb(task.id, { archived: false });
        });
      }
      if (lastPath === "transactionsAll") {
        dispatch(
          updateTransactionTransAll({
            id: transaction.id,
            fields: {
              status: transaction.statusPrevious,
            },
          })
        );
      }
      // Send status change notification
      sendTransactionStatusChangedNotificationEmails(
        transaction,
        oldStatus,
        newStatus,
        currentUserProfile
      );
      toast.success("Transaction successfully made active");
    } catch (error) {
      toast.error(error.message);
    } finally {
    }
  }

  return (
    <div className={isMobile ? null : "text align right"}>
      <Dropdown
        button
        icon="chevron down"
        text={isMobile ? "Actions " : null}
        className={isMobile ? "button icon" : "button mini icon"}
        direction={isMobile ? "right" : "left"}
      >
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => handleView()}>View</Dropdown.Item>
          {transaction.status !== "Archived" ? (
            <>
              {transaction.status !== "Under Contract" && (
                <Dropdown.Item onClick={() => handleSetUnderContract()}>
                  Set Status to Under Contract
                </Dropdown.Item>
              )}
              {transaction.status !== "Complete" && (
                <Dropdown.Item onClick={() => handleSetComplete()}>
                  Set Status to Complete
                </Dropdown.Item>
              )}
              <Dropdown.Item onClick={() => handleArchive()}>
                Archive
              </Dropdown.Item>
            </>
          ) : (
            <Dropdown.Item onClick={() => handleMakeActive()}>
              Make Active
            </Dropdown.Item>
          )}
          {(currentUserProfile.role === "agent" ||
            currentUserProfile.role === "assistant") && (
            <Dropdown.Item
              onClick={() =>
                dispatch(
                  openModal({
                    modalType: "TransactionDeleteConfirmModal",
                    modalProps: {
                      transactionId: transaction.id,
                      lastPath: lastPath,
                    },
                  })
                )
              }
            >
              Delete
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
